<template>
  <footer class="d-foot">
    <div class="d-foot-cols">
      <div>
        <div class="d-brand foot-brand">
          <img v-if="showLogo" class="logo-hd" :src="logo" :alt="brandName" @error="logoError = true" />
          <template v-else>
            <span class="mk">{{ markLetter }}</span>
            <span class="nm">{{ siteName }}</span>
          </template>
        </div>
        <p>{{ address }}</p>
        <ul class="d-chan">
          <li v-for="item in channelList" :key="item.name">
            <img :src="item.src" alt="" />
          </li>
        </ul>
      </div>

      <div>
        <h4>{{ brandName }}</h4>
        <a href="javascript:;" @click="jump('conduct')">Rules of Conduct</a>
        <a href="javascript:;" @click="jump('tos')">Terms of service</a>
        <a href="javascript:;" @click="jump('privacy')">Privacy policy</a>
      </div>

      <div>
        <h4>Contact Us</h4>
        <p>Email: {{ email }}</p>
        <p>Contact Center: {{ phone }}</p>
        <p>Office Address: {{ address }}</p>
      </div>
    </div>

    <div class="d-copy">{{ copyRight }}</div>
  </footer>
</template>

<script>
import env from '../assets/js/env'
import dh from '@/assets/js/dHelpers'

const P = (n) => require(`../assets/image/pc/footer/${n}.png`)

const CHANNELS = {
  IDR: ['dana', 'ovo', 'shopeepay', 'linkaja', 'qris', 'astrapay', 'bca', 'bni', 'bri', 'cimb', 'mandiri', 'permata', 'alfamart', 'credit'],
  THB: ['bay', 'bbl', 'credit', 'kbank', 'ktb', 'linepay', 'promptpay', 'scb', 'shopee', 'truemoney'],
  PHP: ['7eleven', 'bpi', 'cebuana', 'gcash', 'grabpay', 'paymaya', 'shopee', 'credit', 'ubp'],
  BRL: ['ame', 'bank_transfer', 'boleto', 'mercado_pago', 'paypal', 'picpay', 'pix'],
  MXN: ['bank_transfer', 'oxxo', 'paycash'],
  VND: ['woori', 'momo', 'viettelpay', 'vnptpay', 'shopee', 'appota', 'zalopay'],
  MYR: ['tng', 'mcash', 'boost', 'grabpay', 'fpx', 'unionpay'],
}

export default {
  data() {
    return {
      isMobile: false,
      brandName: env.brandName,
      // 没配 logo 图时的字标：优先站点名（siteName），没有再用公司名
      siteName: env.siteName || env.brandName,
      logo: env.logo,
      logoError: false,
      email: env.email,
      phone: env.phone,
      address: env.address,
      copyRight: env.copyRight,
      channelList: [],
      currency: this.$store.state.orderInfo.gameCurrency,
    }
  },
  computed: {
    showLogo() {
      return !!this.logo && !this.logoError
    },
    markLetter() {
      return (this.siteName || 'L').trim().charAt(0).toUpperCase()
    },
  },
  mounted() {
    this.isMobile = dh.isMobileUA()
    this.loadChannelList()
  },
  methods: {
    jump(path) {
      this.$router.push({ path: `/${path}` })
    },
    loadChannelList() {
      const key = this.currency || 'IDR'
      const names = CHANNELS[key] || CHANNELS.IDR
      this.channelList = names.map((n) => {
        try {
          return { name: n, src: P(n) }
        } catch (e) {
          return null
        }
      }).filter(Boolean)
    },
  },
}
</script>

<style lang="scss" scoped>
.foot-brand {
  margin-bottom: 12px;
}
</style>
